import { 
    Button,
    Card,
    CardContent,
    Grid,
    TextField,
    Typography,
    makeStyles
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { Header, Page, TablaV2 } from 'components';
import { useEffect, useState } from 'react';
import serviciosReportes from 'utils/serviciosReportes';
import { useForm } from 'react-hook-form';
import NumberFormat from 'react-number-format';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  containerSistemas: {
    paddingTop: theme.spacing(3),
  },
  }));

const AvanceIntegrantes = ({}) => {
  const classes = useStyles();
  const { handleSubmit, register, errors } = useForm();
  const [mensaje, setMensaje] = useState({ open: false });
  const [cargando, setCargando] = useState(false);
  const cerrarMensaje = () => setMensaje({ ...mensaje, open: false });
  const [catalogos, setCatalogos] = useState({ integrantes: [] });
  
  const getMes = (mes) => (mes.toString().length < 2 ? `0${mes}` : mes);
  const dateNow = new Date();
  const monthWithOffset = dateNow.getUTCMonth() + 1;
  const month = getMes(monthWithOffset);
  const date =
    dateNow.getUTCDate().toString().length < 2
      ? `0${dateNow.getUTCDate()}`
      : dateNow.getUTCDate();
  const minicio = getMes(dateNow.getUTCMonth() - 6 + 1);
  const fechafin = `${dateNow.getFullYear()}-${month}-${date}`;
  const fechainicio = `${dateNow.getFullYear()}-${minicio}-${date}`;

  const columns = [
    { label: "INTEGRANTE", name: "nombre", filtrar: true },
    { label: "JEFE DIRECTO", name: "jefe", filtrar: true },
    { label: "PUESTO", name: "nrol", filtrar: true },
    { label: "#TAREAS", name: "nTareas", filtrar: true },
    { label: "#HRS. PROPUESTAS", tamano: '13', name: "tthrsProp",filtrar: true },
    { label: "#HRS. CUMPLIDAS", tamano: '12', name: "tthrsReal", filtrar: true },
    {
      label: "% CUMPLIMIENTO HRS.",
      name: "percentC",
      filtrar: true,
      tamano: '14',
      type: {
        type: 'componente',
        accion: row => (
            <Typography style={{fontSize:12}} align="center">
                <NumberFormat
                value={row["percentC"]}
                thousandSeparator=","
                decimalScale={0}
                suffix="%"
                displayType="text"
                />
          </Typography>
        )
    }
    },{ label: "EFICIENCIA", tamano:'12', name:'eficiencia', filtrar:true }
  ];
  const buscarIntegrantes = (datos) => {
    serviciosReportes.getIntegrantes(
      (res) => {
        console.log(res);
        setCatalogos({ integrantes: res });
      },
      setCargando,
      datos
    );
    
  };
    useEffect(() => {}, []);
    return (
        <Page title="Panel de solicitudes" className={classes.root} mensaje={{ ...mensaje, cerrar: cerrarMensaje }} cargando={cargando}>
            <Card>
                <CardContent>
                    <Header
                        subtitle={
                            <form onSubmit={handleSubmit(buscarIntegrantes)}>
                                <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                                    <Grid item xs>
                                        Indicadores por integrantes
                                    </Grid>
                                    <Grid item xs={5} container spacing={2} alignContent="flex-end" alignItems="center">
                                        <Grid item xs={5}>
                                            <TextField
                                                name="desde"
                                                fullWidth
                                                type="date"
                                                label="Desde"
                                                size="small"
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={register({ required: { value: true, message: 'Campo requerido' } })}
                                                error={errors.desde?.message}
                                                defaultValue={fechainicio}
                                            />
                                        </Grid>
                                        <Grid item xs={5}>
                                            <TextField
                                                name="hasta"
                                                fullWidth
                                                type="date"
                                                label="Hasta"
                                                size="small"
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={register({ required: { value: true, message: 'Campo requerido' } })}
                                                error={errors.hasta?.message}
                                                defaultValue={fechafin}
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Button variant="contained" fullWidth type="submit">
                                                <Search />
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </form>
                        }
                    />
                    <Grid container spacing={4} direction="column" className={classes.containerSistemas}>
                        {catalogos.integrantes?.length ? (
                            <Grid item container>
                                <Grid item xs>
                                    <TablaV2 keyTabla='indIntegrantes' columnKey="idpersona" columns={columns} rows={catalogos.integrantes} filterGeneralDisabled={false}/>
                                </Grid>
                            </Grid>
                        ) : (
                            <Card>
                                <CardContent>
                                    <Typography variant="h4" align="center">
                                        No hay información para mostrar
                                    </Typography>
                                </CardContent>
                            </Card>
                        )}
                    </Grid>
                </CardContent>
            </Card>
        </Page>
    );
  };
export default AvanceIntegrantes;
